import React from 'react'

export interface CurrencyContextValue {
  symbol: string
}

const CurrencyContext = React.createContext<CurrencyContextValue>({
  symbol: '$'
})

export default CurrencyContext
